import { render } from "./Contactform.vue?vue&type=template&id=e4f87c7e&scoped=true"
import script from "./Contactform.vue?vue&type=script&lang=js"
export * from "./Contactform.vue?vue&type=script&lang=js"

import "./Contactform.vue?vue&type=style&index=0&id=e4f87c7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e4f87c7e"

export default script